import { Box, SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export const PointSymbol = ({
  pointShape,
  pointColor,
  billboardBase64,
}: {
  pointShape?: JSX.Element;
  pointColor?: string;
  billboardBase64?: string;
}) => {
  if (billboardBase64) {
    return (
      <img
        src={billboardBase64}
        style={{ width: 20, height: 20, objectFit: "contain" }}
      />
    );
  } else if (pointShape) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
        {pointShape}
      </Box>
    );
  } else {
    return (
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="6" fill={pointColor || "currentColor"} />
      </svg>
    );
  }
};

export const LineSymbol = ({
  lineColor,
  pointColor,
}: {
  lineColor?: string;
  pointColor?: string;
}) => {
  return (
    <svg
      width="22"
      height="13"
      viewBox="0 0 22 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 2.708 10.568 L 8.99 4.542 L 13.035 8.839 L 19.282 3.123"
        stroke={lineColor || "currentColor"}
        strokeWidth="2"
      ></path>
      <circle
        cx="3.279"
        cy="10.001"
        r="2"
        fill={pointColor || "currentColor"}
      ></circle>
      <circle
        cx="8.904"
        cy="4.64"
        r="2"
        fill={pointColor || "currentColor"}
      ></circle>
      <circle
        cx="13.135"
        cy="8.87"
        r="2"
        fill={pointColor || "currentColor"}
      ></circle>
      <circle
        cx="19.126"
        cy="3.302"
        r="2"
        fill={pointColor || "currentColor"}
      ></circle>
    </svg>
  );
};

export const MultiLineSymbol = ({
  lineColor,
  pointColor,
}: {
  lineColor?: string;
  pointColor?: string;
}) => {
  return (
    <svg
      width="22"
      height="13"
      viewBox="0 0 22 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 10.5L9 3.5L20 2.5"
        stroke={lineColor || "currentColor"}
        strokeWidth="2"
      />
      <path
        d="M9 3.5L13 9.5"
        stroke={lineColor || "currentColor"}
        strokeWidth="2"
      />
      <circle cx="2" cy="10.5" r="2" fill={pointColor || "currentColor"} />
      <circle cx="9" cy="3.5" r="2" fill={pointColor || "currentColor"} />
      <circle cx="13" cy="9.5" r="2" fill={pointColor || "currentColor"} />
      <circle cx="20" cy="2.5" r="2" fill={pointColor || "currentColor"} />
    </svg>
  );
};

export const PolygonSymbol = ({
  lineColor,
  polygonColor,
  pointColor,
}: {
  lineColor?: string;
  polygonColor?: string;
  pointColor?: string;
}) => {
  return (
    <svg
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 2.5L2 10.5L14 13.5L18.5 2.5H7Z"
        stroke={lineColor || "currentColor"}
        strokeWidth="2"
        fill={polygonColor || "currentColor"}
      />
      <circle cx="2" cy="10.5" r="2" fill={pointColor || "currentColor"} />
      <circle cx="7" cy="2.5" r="2" fill={pointColor || "currentColor"} />
      <circle cx="14" cy="13.5" r="2" fill={pointColor || "currentColor"} />
      <circle cx="19" cy="2.5" r="2" fill={pointColor || "currentColor"} />
    </svg>
  );
};

export const MultiPolygonSymbol = ({
  lineColor,
  polygonColor,
  pointColor,
}: {
  lineColor?: string;
  polygonColor?: string;
  pointColor?: string;
}) => {
  return (
    <svg
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 2.5L2 10.5L14 13.5M7 2.5H18.5L14 13.5M7 2.5L14 13.5"
        stroke={lineColor || "currentColor"}
        strokeWidth="2"
        fill={polygonColor || "currentColor"}
      />
      <circle cx="2" cy="10.5" r="2" fill={pointColor || "currentColor"} />
      <circle cx="7" cy="2.5" r="2" fill={pointColor || "currentColor"} />
      <circle cx="14" cy="13.5" r="2" fill={pointColor || "currentColor"} />
      <circle cx="19" cy="2.5" r="2" fill={pointColor || "currentColor"} />
    </svg>
  );
};

export const BlockedLayer = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9.33L10.91 5.51L12 4.66L6 0L0 4.67L1.09 5.52L6 9.34V9.33ZM6 1.68L9.83 4.66L6 7.64L2.17 4.66L6 1.68Z"
        fill="currentColor"
      />
      <path
        d="M8 9.47094L5.99 11.0309L1.08 7.21094L0 8.05094L6 12.7109L8 11.1609V9.47094Z"
        fill="currentColor"
      />
      <path
        d="M15.1098 11.0996H14.6598V8.83961C14.6598 7.60961 13.6598 6.59961 12.4198 6.59961C11.1798 6.59961 10.1798 7.59961 10.1798 8.83961V11.0996H9.72984C9.23984 11.0996 8.83984 11.4996 8.83984 11.9896V15.0996C8.83984 15.5896 9.23984 15.9896 9.72984 15.9896H15.0998C15.5898 15.9896 15.9898 15.5896 15.9898 15.0996V11.9896C15.9898 11.4996 15.5898 11.0996 15.0998 11.0996H15.1098ZM13.8098 11.0996H11.0398V8.83961C11.0398 8.06961 11.6598 7.44961 12.4298 7.44961C13.1998 7.44961 13.8198 8.06961 13.8198 8.83961V11.0996H13.8098Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MouseRightClick = () => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 224 289"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ padding: "4px 0px" }}
    >
      <path
        d="M145.49 55.92C149.9 56.18 153.69 52.81 153.94 48.4L156.28 8.47001C156.54 4.06001 153.17 0.270009 148.76 0.0200087C144.35 -0.239991 140.56 3.13001 140.31 7.54001L137.97 47.47C137.71 51.88 141.08 55.67 145.49 55.92Z"
        fill="#000000de"
      />
      <path
        d="M177.95 60.46L201.83 39.22C204.47 36.87 204.23 32.3 201.29 28.99C198.35 25.69 193.83 24.91 191.2 27.26L167.32 48.5C164.68 50.85 164.92 55.42 167.86 58.73C170.8 62.03 175.32 62.81 177.95 60.46Z"
        fill="#000000de"
      />
      <path
        d="M216.43 76.1L176.5 73.76C172.09 73.5 168.3 76.87 168.05 81.28C167.79 85.69 171.16 89.48 175.57 89.73L215.5 92.07C219.91 92.33 223.7 88.96 223.95 84.55C224.21 80.14 220.84 76.35 216.43 76.1Z"
        fill="#000000de"
      />
      <path
        d="M85 48.42C38.06 48.42 0 86.47 0 133.42V203.42C0 250.36 38.06 288.42 85 288.42C131.94 288.42 170 250.36 170 203.42V133.42C170 86.48 131.94 48.42 85 48.42ZM16 138.08C16 100.29 42.66 69.16 77 64.92V144.04H16V138.08ZM154 198.75C154 239.43 123.11 272.42 85 272.42C46.89 272.42 16 239.44 16 198.75V160.04H154V198.75Z"
        fill="#000000de"
      />
    </svg>
  );
};

export const MouseLeftClick = () => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 224 289"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ padding: "4px 0px" }}
    >
      <path
        d="M78.4699 55.92C74.0599 56.18 70.2699 52.81 70.0199 48.4L67.6799 8.47001C67.4199 4.06001 70.7899 0.270009 75.1999 0.0200087C79.6099 -0.239991 83.3999 3.13001 83.6499 7.54001L85.9899 47.47C86.2499 51.88 82.8799 55.67 78.4699 55.92Z"
        fill="#000000de"
      />
      <path
        d="M46.0098 60.46L22.1298 39.22C19.4898 36.87 19.7298 32.3 22.6698 28.99C25.6098 25.69 30.1298 24.91 32.7598 27.26L56.6398 48.5C59.2798 50.85 59.0398 55.42 56.0998 58.73C53.1598 62.03 48.6398 62.81 46.0098 60.46Z"
        fill="#000000de"
      />
      <path
        d="M7.52994 76.1L47.4599 73.76C51.8699 73.5 55.6599 76.87 55.9099 81.28C56.1699 85.69 52.7999 89.48 48.3899 89.73L8.45994 92.07C4.04994 92.33 0.259938 88.96 0.00993785 84.55C-0.250062 80.14 3.11994 76.35 7.52994 76.1Z"
        fill="#000000de"
      />
      <path
        d="M53.96 133.42V203.42C53.96 250.36 92.02 288.42 138.96 288.42C185.9 288.42 223.96 250.36 223.96 203.42V133.42C223.96 86.48 185.9 48.42 138.96 48.42C92.02 48.42 53.96 86.48 53.96 133.42ZM207.96 144.05H146.96V64.93C181.3 69.17 207.96 100.29 207.96 138.09V144.05ZM69.96 160.05H207.96V198.76C207.96 239.44 177.07 272.43 138.96 272.43C100.85 272.43 69.96 239.45 69.96 198.76V160.05Z"
        fill="#000000de"
      />
    </svg>
  );
};

export const CockpitArrow = () => {
  return (
    <svg
      className="infra3d-svgArrow"
      width="30"
      height="26"
      viewBox="0 0 31 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7 0C10.51 0 5.50004 0.79 0.790039 2.26L14.46 26.03C14.87 26.01 15.29 26 15.71 26C16.13 26 16.54 26.01 16.96 26.03L30.63 2.26C25.92 0.79 20.91 0 15.72 0H15.7Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CockpitCameraSelection = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 34 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.3598 9.90602V5.03542C27.3598 4.10722 26.608 3.35542 25.6798 3.35542H23.1598C23.1598 1.80842 21.9068 0.55542 20.3598 0.55542H13.3598C11.8128 0.55542 10.5598 1.80842 10.5598 3.35542H8.03984C7.11164 3.35542 6.35984 4.10722 6.35984 5.03542V9.96482C2.68344 11.5566 0.339844 13.9632 0.339844 16.6554C0.339844 20.5124 5.28884 24.62 11.9388 25.7512V28.4924C11.9388 29.0552 12.5674 29.387 13.0322 29.0706L18.082 25.6336C18.4908 25.3564 18.4908 24.7544 18.082 24.4758L13.0322 20.8988C12.5674 20.5824 11.9388 20.9156 11.9388 21.477V23.7786C6.46904 22.8182 2.43984 19.5268 2.43984 16.654C2.43984 14.876 3.92944 13.2604 6.35984 12.0578V17.074C6.35984 18.0022 7.11164 18.754 8.03984 18.754H25.6798C26.608 18.754 27.3598 18.0022 27.3598 17.074V11.9892C29.8728 13.1974 31.4198 14.8424 31.4198 16.654C31.4198 19.0998 28.743 22.079 24.5318 23.255C24.0502 23.3894 23.7198 23.6918 23.7198 24.1916V24.4128C23.7198 24.8748 24.1594 25.3466 24.606 25.2276C29.9792 23.7912 33.5198 20.028 33.5198 16.654C33.5198 13.9282 31.1174 11.495 27.3598 9.90462V9.90602ZM16.9998 16.7254C13.714 16.7254 11.0498 14.0612 11.0498 10.7754C11.0498 7.48962 13.714 4.82542 16.9998 4.82542C20.2856 4.82542 22.9498 7.48962 22.9498 10.7754C22.9498 14.0612 20.2856 16.7254 16.9998 16.7254Z"
        fill="currentColor"
      />
      <path
        d="M16.9994 14.6255C19.1257 14.6255 20.8494 12.9018 20.8494 10.7755C20.8494 8.64924 19.1257 6.92554 16.9994 6.92554C14.8731 6.92554 13.1494 8.64924 13.1494 10.7755C13.1494 12.9018 14.8731 14.6255 16.9994 14.6255Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PointCloud = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.15 20.5H5.85C2.63 20.5 0 17.88 0 14.65C0 11.9 1.89 9.59 4.51 8.98C5.51 5.76 8.53 3.5 11.97 3.5C15.41 3.5 18.41 5.76 19.42 8.96C22.08 9.54 24.01 11.86 24.01 14.65C24.01 17.87 21.39 20.5 18.16 20.5H18.15ZM11.96 5.68C9.3 5.68 6.99 7.56 6.45 10.16L6.29 10.95L5.49 11.03C3.6 11.21 2.18 12.77 2.18 14.66C2.18 16.68 3.82 18.33 5.85 18.33H18.15C20.17 18.33 21.82 16.69 21.82 14.66C21.82 12.75 20.37 11.19 18.45 11.03L17.64 10.96L17.47 10.16C16.93 7.57 14.62 5.68 11.96 5.68Z"
        fill="currentColor"
      />
      <path
        d="M17.2799 17.1C18.02 17.1 18.6199 16.5001 18.6199 15.76C18.6199 15.02 18.02 14.42 17.2799 14.42C16.5399 14.42 15.9399 15.02 15.9399 15.76C15.9399 16.5001 16.5399 17.1 17.2799 17.1Z"
        fill="currentColor"
      />
      <path
        d="M5.42008 15.6C6.16014 15.6 6.76008 15.0001 6.76008 14.26C6.76008 13.52 6.16014 12.92 5.42008 12.92C4.68002 12.92 4.08008 13.52 4.08008 14.26C4.08008 15.0001 4.68002 15.6 5.42008 15.6Z"
        fill="currentColor"
      />
      <path
        d="M12.36 8.84001C12.857 8.84001 13.26 8.43706 13.26 7.94001C13.26 7.44295 12.857 7.04001 12.36 7.04001C11.8629 7.04001 11.46 7.44295 11.46 7.94001C11.46 8.43706 11.8629 8.84001 12.36 8.84001Z"
        fill="currentColor"
      />
      <path
        d="M10.0399 10.22C10.5369 10.22 10.9399 9.81707 10.9399 9.32001C10.9399 8.82296 10.5369 8.42001 10.0399 8.42001C9.54284 8.42001 9.13989 8.82296 9.13989 9.32001C9.13989 9.81707 9.54284 10.22 10.0399 10.22Z"
        fill="currentColor"
      />
      <path
        d="M19.5201 14.47C20.0172 14.47 20.4201 14.0671 20.4201 13.57C20.4201 13.073 20.0172 12.67 19.5201 12.67C19.0231 12.67 18.6201 13.073 18.6201 13.57C18.6201 14.0671 19.0231 14.47 19.5201 14.47Z"
        fill="currentColor"
      />
      <path
        d="M7.66001 17.36C8.15707 17.36 8.56001 16.9571 8.56001 16.46C8.56001 15.9629 8.15707 15.56 7.66001 15.56C7.16295 15.56 6.76001 15.9629 6.76001 16.46C6.76001 16.9571 7.16295 17.36 7.66001 17.36Z"
        fill="currentColor"
      />
      <path
        d="M13.6701 13.83V10.96H11.0501V13.83H9.09009L12.3601 17.1L15.6301 13.83H13.6701Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LoadingLogo = () => {
  return (
    <svg
      width="150"
      height="160"
      viewBox="0 0 300 322"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2976_9028)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M176.03 0.927525C176.03 0.927525 170.024 2.02422 164.04 3.15035C158.063 4.27648 152.109 5.43205 152.109 5.43205C145.831 6.83052 139.655 9.01654 133.841 11.8208C128.033 14.6251 122.55 18.0698 117.64 21.9634C112.731 25.857 108.337 30.2364 104.716 34.8881C101.094 39.5472 98.2386 44.4934 96.4353 49.4616C96.4353 49.4616 95.4564 52.2512 93.9991 56.5864C92.5417 60.9143 90.6059 66.832 88.6775 73.0441C86.7491 79.2562 84.8649 85.7996 83.4664 90.8341C82.0753 95.8685 81.1553 99.3353 81.1553 99.3353C81.1553 99.3353 87.7943 97.4289 98.4226 94.5952C103.744 93.1746 110.317 91.5554 117.714 89.8625C121.409 89.016 125.339 88.1623 129.439 87.3085C133.539 86.462 137.8 85.6229 142.172 84.8059C146.545 83.9963 151.02 83.2161 155.524 82.4874C160.029 81.7514 164.548 81.0742 169.016 80.456C173.483 79.8377 177.87 79.271 182.102 78.7778C186.327 78.2847 190.383 77.8578 194.188 77.5118C201.799 76.82 208.217 76.3195 212.729 75.9883C217.248 75.6644 219.853 75.5098 219.853 75.5098C219.853 75.5098 220.111 71.9033 220.501 66.729C220.891 61.5546 221.399 54.9377 221.907 48.7771C222.408 42.6091 222.901 36.846 223.261 32.6579C223.629 28.4773 223.858 25.8055 223.858 25.8055C224.292 21.1169 223.129 16.9142 220.737 13.3591C218.352 9.80409 214.79 6.88204 210.381 4.70338C205.979 2.51736 200.761 1.05265 194.968 0.39022C189.183 -0.27221 182.809 -0.117643 176.023 0.920164L176.03 0.927525ZM202.321 62.9531C202.321 62.9531 194.747 63.6744 183.677 64.9846C178.142 65.6396 171.835 66.5081 165.254 67.5239C158.674 68.547 151.844 69.7246 145.234 70.9906C138.632 72.2566 132.258 73.5961 126.48 74.8989C120.702 76.2017 115.499 77.453 111.208 78.557C102.625 80.7651 97.1714 82.274 97.1714 82.274C97.1714 82.274 100.005 72.4921 102.868 63.3579C105.739 54.2311 108.602 45.7152 108.602 45.7152C109.853 42.2043 111.892 38.6787 114.52 35.3224C117.147 31.9661 120.364 28.779 123.97 25.938C127.577 23.0895 131.61 20.5575 135.872 18.4893C140.134 16.4137 144.646 14.8018 149.194 13.7713C149.194 13.7713 155.289 12.5642 161.412 11.3939C167.536 10.2236 173.697 9.08278 173.697 9.08278C178.65 8.30994 183.28 8.2069 187.446 8.68532C191.612 9.1711 195.307 10.2384 198.391 11.8355C204.551 15.0152 208.062 20.3441 207.083 27.0052C207.083 27.0052 205.935 35.2193 204.735 44.1916C203.543 53.1565 202.314 62.9605 202.314 62.9605L202.321 62.9531Z"
          style={{ animation: "loadingFirst 2s linear infinite" }}
          className="loadingFirst"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.10859 119.547L1.39798 140.428C0.249766 146.353 -0.177134 151.866 0.0657571 156.819C0.308648 161.773 1.19925 166.174 2.6934 169.84C5.68169 177.178 11.0842 181.263 18.1796 179.769C18.1796 179.769 26.379 178.083 35.6604 176.287C44.9417 174.484 55.4744 172.578 55.4744 172.578C55.4744 172.578 56.5784 163.65 58.5657 150.681C59.5594 144.196 60.8695 136.873 62.4078 129.292C63.1733 125.501 63.9976 121.652 64.8662 117.824C65.7347 113.997 66.64 110.177 67.5821 106.453C69.4517 98.9892 71.4022 91.857 73.2864 85.4609C75.1633 79.0647 76.9666 73.3458 78.527 68.694C81.6477 59.3832 83.7381 53.5317 83.7381 53.5317C83.7381 53.5317 72.7859 57.499 62.8274 61.4662C52.8762 65.426 43.845 69.3197 43.845 69.3197C39.8484 71.1082 35.7855 73.8021 31.9066 77.1437C28.0277 80.4853 24.3181 84.4967 20.9691 88.9276C17.6202 93.3585 14.6024 98.2679 12.0925 103.435C9.56795 108.602 7.52914 114.048 6.11596 119.539L6.10859 119.547ZM69.1499 68.3407C69.1499 68.3407 67.5527 73.1102 65.19 80.581C64.0124 84.3127 62.6654 88.8246 61.2522 93.8001C59.8391 98.7757 58.3744 104.244 56.9612 109.905C55.548 115.557 54.201 121.387 53.0013 126.988C51.8016 132.596 50.749 137.955 49.91 142.673C48.2392 152.094 47.2382 158.556 47.2382 158.556C47.2382 158.556 39.9146 160.293 33.1137 161.964C26.3127 163.635 19.9828 165.24 19.9828 165.24C14.8453 166.587 10.9443 163.966 8.80248 158.924C6.66062 153.875 6.22636 146.515 7.91188 137.896L12.8286 116.58C13.8738 112.613 15.3826 108.653 17.2448 104.87C19.0996 101.094 21.3077 97.4877 23.744 94.2418C28.6312 87.7426 34.4901 82.5241 40.0986 80.0437C40.0986 80.0437 46.929 77.1511 54.1863 74.2216C61.4436 71.2922 69.1425 68.3407 69.1425 68.3407H69.1499Z"
          style={{ animation: "loadingFourth 2s linear infinite" }}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.9602 193.805C18.9602 193.805 18.6878 197.677 18.3787 203.521C18.0696 209.358 17.7825 217.182 17.6942 225.035C17.6059 232.889 17.7089 240.742 17.8929 246.608C18.0696 252.482 18.2536 256.39 18.2536 256.39C18.7173 263.633 20.0201 270.632 22.0589 277.124C24.0903 283.623 26.8431 289.659 30.1773 294.995C33.5116 300.324 37.4346 304.968 41.7772 308.619C46.1125 312.27 50.882 314.912 55.806 316.178L75.6201 320.94C81.5819 322.273 87.2126 321.934 92.3869 320.079C97.5612 318.232 102.235 314.787 106.173 309.915C110.111 305.042 113.246 298.668 115.255 291.079C116.264 287.282 116.993 283.174 117.397 278.825C117.802 274.467 117.89 269.86 117.603 265.075C117.603 265.075 117.368 259.894 117.118 252.07C116.993 248.161 116.897 243.576 116.845 238.652C116.794 233.728 116.786 228.48 116.845 223.225C116.904 217.969 117.022 212.736 117.177 207.849C117.338 202.962 117.53 198.428 117.736 194.563C118.148 186.842 118.487 181.749 118.487 181.749C118.487 181.749 109.853 182.544 97.8704 183.758C91.879 184.362 85.3799 185.069 78.8512 185.827C72.33 186.577 65.8234 187.365 59.7585 188.138C53.6936 188.911 48.0482 189.654 43.0874 190.339C38.1191 191.023 33.7618 191.634 30.273 192.142C23.2881 193.158 18.9675 193.805 18.9749 193.805H18.9602ZM101.926 264.008C102.338 270.603 101.764 276.727 100.424 282.085C99.0848 287.443 96.9724 292.029 94.3006 295.606C91.6288 299.183 88.4197 301.811 84.8205 303.327C81.2286 304.843 77.2541 305.278 73.0366 304.468L53.3182 300.434C49.8515 299.676 46.4878 297.888 43.3891 295.326C40.2904 292.758 37.4493 289.423 35.0352 285.552C32.6136 281.68 30.6042 277.264 29.1174 272.487C27.6307 267.718 26.6664 262.573 26.3205 257.259C26.3205 257.259 26.1954 254.212 26.0482 249.626C25.9083 245.041 25.7685 238.917 25.739 232.786C25.7096 226.647 25.7906 220.523 25.8863 215.93C25.9819 211.338 26.0776 208.276 26.0776 208.276C26.0776 208.276 29.6621 207.967 35.3811 207.488C38.2443 207.245 41.7478 206.958 45.6856 206.642C49.6233 206.325 54.0175 205.979 58.6545 205.626C63.2989 205.273 68.2082 204.912 73.0439 204.573C77.887 204.228 82.6271 203.911 86.9255 203.631C95.515 203.072 101.624 202.697 101.624 202.697C101.624 202.697 101.484 206.517 101.352 212.265C101.212 218.013 101.116 225.698 101.153 233.389C101.19 241.088 101.367 248.75 101.558 254.484C101.757 260.21 101.926 264.016 101.926 264.016V264.008Z"
          style={{ animation: "loadingThird 2s linear infinite" }}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M227.758 108.955C226.323 108.896 224.88 108.889 223.415 108.933C223.415 108.933 219.433 109.125 213.523 109.463C207.613 109.802 199.818 110.332 192.163 110.965C184.516 111.598 177.045 112.326 171.532 112.915C166.02 113.504 162.413 113.923 162.413 113.923C162.413 113.923 161.478 121.159 160.168 132.553C159.513 138.249 158.814 145.161 158.129 152.808C157.783 156.628 157.459 160.647 157.143 164.783C156.834 168.927 156.539 173.189 156.274 177.517C156.009 181.845 155.774 186.217 155.568 190.559C155.369 194.909 155.2 199.215 155.067 203.425C154.802 211.838 154.663 219.765 154.655 226.588C154.633 240.234 154.78 249.31 154.78 249.31C154.78 249.31 158.6 249.405 164.466 249.53C170.34 249.655 178.341 249.81 186.599 249.95C194.857 250.09 203.344 250.207 209.799 250.288C216.254 250.362 220.618 250.406 220.618 250.406C223.033 250.421 225.417 250.281 227.758 250.001C232.954 249.368 237.959 248.014 242.655 246.034C249.471 243.164 255.639 238.968 260.813 233.794C265.988 228.612 270.154 222.466 272.995 215.688C275.836 208.909 277.352 201.519 277.264 193.82C277.264 193.82 277.109 184.134 276.925 174.639C276.741 165.137 276.528 155.863 276.528 155.863C276.336 148.915 274.651 142.379 271.788 136.579C268.932 130.771 264.928 125.671 260.099 121.505C255.264 117.339 249.618 114.078 243.421 111.929C238.504 110.221 233.241 109.206 227.751 108.977L227.758 108.955ZM227.758 272.863C225.498 273.025 223.209 273.098 220.906 273.061C220.906 273.061 215.164 272.951 206.693 272.737C202.461 272.634 197.588 272.487 192.458 272.325C187.32 272.156 181.933 271.957 176.648 271.744C171.363 271.53 166.211 271.302 161.478 271.074C156.745 270.846 152.425 270.625 148.804 270.434C141.568 270.036 136.909 269.764 136.909 269.764C136.909 269.764 136.85 268.638 136.77 266.57V195.299C137.027 189.816 137.351 184.296 137.734 178.856C138.116 173.358 138.551 167.956 139.022 162.73C139.493 157.504 140.008 152.462 140.538 147.685C141.075 142.908 141.613 138.389 142.157 134.186C142.695 129.991 143.232 126.112 143.747 122.645C145.815 108.779 147.28 100.093 147.28 100.093C147.28 100.093 151.689 99.4089 158.483 98.4447C161.883 97.9663 165.909 97.4216 170.296 96.8843C174.683 96.3396 179.437 95.795 184.273 95.2945C189.109 94.794 194.018 94.3376 198.67 93.9549C203.322 93.5648 207.708 93.2483 211.506 93.0054C219.102 92.527 224.232 92.2767 224.232 92.2767C225.41 92.2326 226.588 92.2178 227.751 92.2326C231.357 92.262 234.905 92.527 238.364 93.0349C242.942 93.6973 247.381 94.7645 251.65 96.2072C255.911 97.6498 259.996 99.4751 263.853 101.639C267.717 103.81 271.361 106.328 274.724 109.161C278.095 111.995 281.194 115.153 283.962 118.605C286.729 122.057 289.173 125.803 291.226 129.8C293.28 133.796 294.943 138.065 296.158 142.555C297.365 147.038 298.123 151.748 298.358 156.606C298.358 156.606 298.734 165.807 299.065 175.22C299.323 182.514 299.543 189.912 299.624 192.878V198.729C299.477 202.535 299.058 206.288 298.366 209.961C297.409 215.069 295.922 220.023 293.979 224.77C292.028 229.518 289.614 234.044 286.781 238.291C283.947 242.538 280.701 246.505 277.094 250.127C273.488 253.748 269.528 257.023 265.274 259.879C261.019 262.742 256.478 265.193 251.709 267.173C246.939 269.16 241.941 270.677 236.789 271.678C233.83 272.252 230.805 272.657 227.751 272.877L227.758 272.863Z"
          style={{
            animation: "loadingSecond 2s linear infinite",
          }}
        />
      </g>
    </svg>
  );
};

export const Infra3dLogo = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m 13.854036,0.06980398 c 0,0 -0.447992,0.08180335 -0.894343,0.16580229 C 12.513864,0.31960519 12.06975,0.40580008 12.06975,0.40580008 11.601469,0.51011307 11.140796,0.67317006 10.707125,0.88234203 10.273902,1.091517 9.8649206,1.3484599 9.4986801,1.6388866 9.1325137,1.9293133 8.8047616,2.2559763 8.5346687,2.6029503 8.2645008,2.9504762 8.051514,3.3194172 7.9170046,3.6899992 c 0,0 -0.073017,0.2080785 -0.1817182,0.5314445 C 7.6265778,4.5442652 7.4821848,4.9856714 7.3383438,5.4490368 7.1945033,5.9124022 7.0539592,6.4004792 6.9496437,6.7760067 6.8458807,7.1515267 6.7772571,7.410118 6.7772571,7.410118 c 0,0 0.4952084,-0.1421998 1.2879816,-0.3535677 C 8.4621664,6.9505866 8.9524516,6.8298094 9.5041996,6.7035346 9.7798125,6.6403933 10.072954,6.5767153 10.378776,6.5130293 c 0.305823,-0.063141 0.623654,-0.1257302 0.949765,-0.1866708 0.326186,-0.060389 0.65998,-0.1185843 0.995937,-0.1729386 0.336031,-0.054899 0.673107,-0.1054117 1.006378,-0.151524 0.333198,-0.046117 0.660428,-0.08839 0.976096,-0.1251781 0.315146,-0.03678 0.617686,-0.068624 0.901504,-0.094432 0.567711,-0.051602 1.046435,-0.088935 1.382988,-0.1136393 0.337076,-0.024159 0.531385,-0.035692 0.531385,-0.035692 0,0 0.01925,-0.2690117 0.04833,-0.6549669 0.02909,-0.3859627 0.06698,-0.8795226 0.104874,-1.3390466 0.03737,-0.460076 0.07414,-0.8899502 0.100996,-1.2023439 0.02745,-0.3118343 0.04453,-0.511126 0.04453,-0.511126 C 17.453937,1.5757455 17.367188,1.2622628 17.188767,0.99708503 17.010868,0.73191401 16.745176,0.513956 16.416305,0.35144801 16.087956,0.18839104 15.698741,0.07913715 15.266637,0.02972598 14.835129,-0.01968521 14.359688,-0.00815593 13.853514,0.06925492 Z m 1.961067,4.62653692 c 0,0 -0.564951,0.053802 -1.390671,0.1515312 -0.41286,0.048857 -0.883304,0.1136391 -1.374186,0.1894082 -0.490807,0.076314 -1.000263,0.164152 -1.493308,0.2585843 -0.492448,0.094432 -0.96789,0.1943464 -1.398876,0.291523 C 9.7270771,5.6845647 9.3389812,5.7778999 9.0189117,5.8602482 8.378699,6.0249523 7.971911,6.1375024 7.971911,6.1375024 c 0,0 0.2113605,-0.7296398 0.4249138,-1.4109671 C 8.6109748,4.04576 8.8245281,3.4105523 8.8245281,3.4105523 8.9178414,3.1486714 9.0699318,2.8856941 9.2659566,2.635345 9.4619065,2.3849959 9.7018652,2.1472676 9.9708396,1.9353552 10.239889,1.7228833 10.540713,1.5340194 10.858619,1.3797508 c 0.317906,-0.1548207 0.65446,-0.2750536 0.993699,-0.3519194 0,0 0.454631,-0.0900386 0.91135,-0.1773322 0.456794,-0.0872936 0.916348,-0.17238827 0.916348,-0.17238827 0.369449,-0.0576468 0.714804,-0.0653326 1.025549,-0.0296467 0.310745,0.0362345 0.586358,0.11584546 0.816396,0.23497445 0.45948,0.23717632 0.721368,0.63466322 0.648343,1.13151992 0,0 -0.08563,0.6126963 -0.175139,1.2819473 -0.08891,0.6686988 -0.180584,1.399987 -0.180584,1.399987 z"
          style={{ fill: "#C6C6C6" }}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M 1.1794633,8.9177249 0.82809513,10.475255 c -0.0856462,0.441951 -0.117489,0.85317 -0.0993716,1.222618 0.0181174,0.369523 0.0845481,0.697797 0.19599798,0.971246 0.22289899,0.547348 0.62587649,0.852051 1.15512799,0.740613 0,0 0.6115998,-0.12576 1.3039068,-0.259726 0.6922995,-0.134487 1.477942,-0.276657 1.477942,-0.276657 0,0 0.082348,-0.665946 0.2305825,-1.633314 0.074121,-0.483721 0.1718423,-1.02995 0.2865853,-1.5954227 C 5.4359652,9.3618386 5.4974505,9.0747385 5.56224,8.7892051 5.6270221,8.5037457 5.6945491,8.2188091 5.7648214,7.9410332 5.9042763,7.3843023 6.0497655,6.8523058 6.1903096,6.3752156 6.3303091,5.898118 6.4648189,5.4715407 6.5812099,5.1245593 6.8139856,4.4300592 6.96991,3.9935912 6.96991,3.9935912 c 0,0 -0.8169331,0.2959241 -1.5597455,0.5918407 C 4.6678965,4.8807965 3.9942521,5.1712306 3.9942521,5.1712306 3.6961425,5.3046363 3.3930876,5.5055764 3.1037573,5.7548291 2.8144271,6.0040817 2.5377251,6.3032952 2.2879205,6.6337995 2.0381234,6.9643038 1.8130233,7.3305001 1.6258079,7.7159182 1.4374997,8.1013289 1.2854233,8.50755 1.180013,8.9171281 Z M 5.8817645,5.0982065 c 0,0 -0.1191364,0.3557605 -0.2953719,0.9130136 C 5.4985546,6.2895704 5.3980805,6.6261165 5.292669,6.9972429 5.1872647,7.3683773 5.0780116,7.776262 4.9725998,8.1985204 4.8671882,8.6201075 4.7667143,9.0549721 4.6772278,9.4727549 4.5877412,9.89106 4.5092269,10.290792 4.4466452,10.642712 c -0.1246262,0.70272 -0.1992916,1.184725 -0.1992916,1.184725 0,0 -0.5462732,0.129564 -1.0535577,0.254206 -0.507292,0.124641 -0.9794443,0.244359 -0.9794443,0.244359 C 1.8311414,12.426476 1.5401627,12.230973 1.3804027,11.854886 1.2206397,11.478278 1.1882479,10.929289 1.3139721,10.286391 L 1.6807142,8.6964141 C 1.7586764,8.4005125 1.8712191,8.1051326 2.0101221,7.8229557 2.1484731,7.5413011 2.3131769,7.2723043 2.4949025,7.03019 2.8594427,6.5454094 3.2964627,6.1561573 3.7148051,5.9711421 c 0,0 0.509485,-0.215761 1.0508127,-0.4342747 C 5.3069456,5.318361 5.8812129,5.0982065 5.8812129,5.0982065 Z"
          style={{ fill: "#C6C6C6" }}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m 2.1380751,14.456688 c 0,0 -0.020319,0.288816 -0.043374,0.724724 -0.023056,0.435387 -0.044471,1.018985 -0.051057,1.604747 -0.00659,0.585836 0.0011,1.171597 0.014821,1.609147 0.01318,0.438146 0.026905,0.729647 0.026905,0.729647 0.034588,0.540261 0.1317647,1.062322 0.2838404,1.546566 0.1515237,0.484765 0.3568573,0.934995 0.6055579,1.333012 0.248708,0.397494 0.5413278,0.743893 0.8652458,1.016224 0.3233734,0.272332 0.6791342,0.469401 1.0464193,0.563832 l 1.4779497,0.355202 c 0.4446956,0.09943 0.8646936,0.07414 1.2506489,-0.06422 0.3859553,-0.137769 0.7345779,-0.394735 1.0283165,-0.758141 0.2937381,-0.363481 0.5275806,-0.838923 0.6774335,-1.404992 0.075262,-0.283221 0.1296387,-0.58964 0.1597734,-0.914035 0.030211,-0.325067 0.036775,-0.668707 0.015364,-1.025624 0,0 -0.01753,-0.386455 -0.036174,-0.970053 -0.00932,-0.291576 -0.016482,-0.633574 -0.020363,-1.000859 -0.00383,-0.367286 -0.00442,-0.758738 0,-1.150713 0.00442,-0.392049 0.013202,-0.782382 0.024765,-1.146908 0.01201,-0.364525 0.026331,-0.70272 0.041695,-0.991013 0.030733,-0.575916 0.056017,-0.955806 0.056017,-0.955806 0,0 -0.6440168,0.0593 -1.5378086,0.149852 -0.4469033,0.04505 -0.931676,0.09779 -1.4186573,0.154329 -0.4864219,0.05594 -0.971754,0.11472 -1.4241398,0.172379 -0.4523857,0.05766 -0.8734806,0.11308 -1.2435106,0.164174 -0.3705895,0.05102 -0.6956039,0.09659 -0.9558363,0.134487 -0.5210092,0.07579 -0.8432862,0.124045 -0.8427343,0.124045 z m 6.1884853,5.236498 c 0.030733,0.491926 -0.012085,0.94872 -0.1120358,1.348377 -0.099892,0.399658 -0.2574573,0.741732 -0.4567493,1.008542 -0.1992914,0.266812 -0.4386608,0.462836 -0.7071279,0.575916 -0.267923,0.11308 -0.5643841,0.145527 -0.8789704,0.08511 L 4.7008656,22.41023 C 4.4422817,22.35369 4.1913806,22.220322 3.9602461,22.02922 3.7291116,21.837671 3.5171918,21.58891 3.3371221,21.30017 3.156493,21.011354 3.0066103,20.681961 2.8957087,20.325641 2.7848145,19.969918 2.7128866,19.586148 2.6870857,19.189772 c 0,0 -0.00933,-0.227278 -0.020311,-0.569351 -0.010435,-0.341999 -0.020863,-0.798793 -0.023063,-1.256109 -0.00219,-0.457913 0.00385,-0.914707 0.010987,-1.257302 0.00713,-0.342522 0.014269,-0.570919 0.014269,-0.570919 0,0 0.2673708,-0.02305 0.6939555,-0.05878 0.2135684,-0.01813 0.4748972,-0.03953 0.7686208,-0.0631 0.2937162,-0.02365 0.6214831,-0.04945 0.9673606,-0.07578 0.3464294,-0.02633 0.7126182,-0.05326 1.0733173,-0.07854 0.3612507,-0.02573 0.7148184,-0.04938 1.0354395,-0.07026 0.6406976,-0.04169 1.0963726,-0.06967 1.0963726,-0.06967 0,0 -0.010445,0.284937 -0.020288,0.713685 -0.010445,0.428748 -0.017605,1.001978 -0.014842,1.575656 0.00278,0.574274 0.015965,1.14579 0.030211,1.573493 0.014842,0.427107 0.027449,0.711 0.027449,0.711 z"
          style={{ fill: "#C6C6C6" }}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m 17.712469,8.1276593 c -0.107038,-0.00442 -0.214672,-0.00492 -0.323948,-0.00164 0,0 -0.29702,0.014321 -0.737852,0.039533 -0.440831,0.025287 -1.022267,0.064819 -1.593259,0.1120352 -0.570396,0.047215 -1.127664,0.1015181 -1.538883,0.145452 -0.411144,0.043935 -0.680193,0.075188 -0.680193,0.075188 0,0 -0.06974,0.5397391 -0.167457,1.3896263 -0.04885,0.4248692 -0.100996,0.9404412 -0.15209,1.5108362 -0.02581,0.284937 -0.04998,0.584718 -0.07355,0.893225 -0.02305,0.309104 -0.04505,0.62701 -0.06482,0.949839 -0.01977,0.322829 -0.0373,0.64894 -0.05266,0.972813 -0.01484,0.32447 -0.02745,0.645658 -0.03737,0.959685 -0.01977,0.627533 -0.03014,1.218814 -0.03073,1.727747 -0.0016,1.017866 0.0093,1.694852 0.0093,1.694852 0,0 0.284937,0.0071 0.722487,0.01641 0.438146,0.0093 1.034947,0.02088 1.650918,0.03133 0.61597,0.01044 1.249022,0.01917 1.730506,0.02521 0.481484,0.0055 0.806998,0.0088 0.806998,0.0088 0.180136,0.0011 0.357961,-0.0093 0.532578,-0.03021 0.387574,-0.04722 0.760901,-0.148212 1.111179,-0.295902 0.508411,-0.214075 0.968487,-0.527058 1.35442,-0.912991 0.386007,-0.38653 0.696752,-0.844965 0.908665,-1.350541 0.211912,-0.505651 0.324992,-1.056877 0.318428,-1.631151 0,0 -0.01156,-0.722487 -0.02529,-1.430727 -0.01372,-0.708762 -0.02961,-1.400517 -0.02961,-1.400517 -0.01432,-0.518256 -0.140007,-1.005782 -0.35356,-1.438408 C 20.783663,9.7549333 20.485001,9.3745204 20.124802,9.063775 19.764155,8.7530297 19.343016,8.5097895 18.880777,8.3494938 18.514014,8.2220926 18.121443,8.1463828 17.711939,8.1293015 Z m 0,12.2260277 c -0.168575,0.01208 -0.339314,0.01753 -0.511096,0.01477 0,0 -0.428301,-0.0082 -1.060159,-0.02417 -0.315669,-0.0077 -0.679149,-0.01865 -1.0618,-0.03073 -0.383247,-0.01261 -0.785068,-0.02745 -1.179281,-0.04334 -0.394212,-0.01596 -0.778503,-0.03297 -1.131542,-0.04998 -0.353038,-0.01701 -0.67527,-0.03349 -0.945363,-0.04774 -0.53974,-0.02969 -0.887258,-0.04998 -0.887258,-0.04998 0,0 -0.0044,-0.08399 -0.01037,-0.238243 v -5.316156 c 0.01917,-0.408982 0.04334,-0.820723 0.07191,-1.226497 0.02849,-0.4101 0.06094,-0.813039 0.09607,-1.202851 0.03513,-0.389812 0.07355,-0.765898 0.11308,-1.122218 0.04006,-0.35632 0.08019,-0.693396 0.120762,-1.006901 0.04013,-0.3129091 0.08019,-0.6022467 0.1186,-0.8608529 0.154254,-1.0342757 0.263529,-1.6821714 0.263529,-1.6821714 0,0 0.328871,-0.051028 0.835641,-0.122948 0.253608,-0.035687 0.553911,-0.076314 0.881141,-0.1163916 0.327229,-0.040631 0.681834,-0.081252 1.042555,-0.1185843 0.360722,-0.037332 0.726888,-0.071376 1.073884,-0.099922 0.346997,-0.029098 0.674152,-0.052706 0.957447,-0.070824 0.566592,-0.035687 0.949243,-0.054354 0.949243,-0.054354 0.08787,-0.00328 0.175736,-0.00437 0.262485,-0.00328 0.268974,0.00219 0.533622,0.021958 0.791632,0.059844 0.341477,0.049411 0.672585,0.1290122 0.991013,0.2366246 0.317832,0.1076045 0.622535,0.243755 0.910232,0.4051622 0.288218,0.1619364 0.560028,0.349756 0.810876,0.5610718 0.251446,0.2113903 0.482602,0.4469481 0.68907,0.7044358 0.206393,0.2574871 0.388693,0.5369043 0.541828,0.8350439 0.153209,0.2980646 0.277254,0.6164929 0.367881,0.9514059 0.09003,0.33439 0.146571,0.685713 0.1641,1.048075 0,0 0.02804,0.68631 0.05274,1.388433 0.01924,0.544065 0.03566,1.095888 0.04169,1.317124 v 0.436431 c -0.01097,0.283893 -0.04222,0.563832 -0.09384,0.837804 -0.07138,0.38101 -0.1823,0.750532 -0.32723,1.104615 -0.145527,0.354157 -0.325589,0.691755 -0.536905,1.008542 -0.21139,0.316787 -0.453512,0.612689 -0.722561,0.882857 -0.268974,0.270093 -0.564353,0.514378 -0.881663,0.727409 -0.317384,0.213553 -0.656101,0.396376 -1.011824,0.544065 -0.355798,0.148212 -0.728603,0.261367 -1.112895,0.336032 -0.220714,0.04282 -0.446351,0.07302 -0.674151,0.08944 z"
          style={{ fill: "#0D92D2" }}
        />
      </svg>
    </SvgIcon>
  );
};

export const AxisPanel = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4995 16.5V19.5H3.49953V16.5H20.4995ZM20.4995 4.5V7.5H14.0562C14.0333 7.50863 13.9884 7.52574 13.9214 7.56348L13.9224 7.56445C13.7985 7.63432 13.6427 7.74232 13.4546 7.89551L13.2554 8.06445C12.8303 8.43772 12.3701 8.9155 11.8696 9.45508L11.355 10.0137C11.2083 10.1737 11.0578 10.3363 10.9058 10.5H20.4995V13.5H3.49953V10.5H6.44094C6.46351 10.4917 6.50895 10.4743 6.57766 10.4355L6.71144 10.3525C6.85653 10.2565 7.03357 10.12 7.24367 9.93555L7.45949 9.74023C7.96915 9.26549 8.52822 8.65816 9.14406 7.98633L9.65969 7.42578C10.1862 6.85795 10.7394 6.28081 11.2749 5.81055L11.5513 5.57617C11.8343 5.34497 12.1362 5.12744 12.4487 4.95117L12.7329 4.80469C13.0345 4.66323 13.3867 4.54419 13.7739 4.50977L13.7847 4.50879L13.7964 4.50781L13.978 4.5H20.4995Z"
        stroke="currentColor"
      />
    </svg>
  );
};

export const AxisPanelFilled = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4995 16.5V19.5H3.49953V16.5H20.4995ZM20.4995 4.5V7.5H14.0562C14.0333 7.50863 13.9884 7.52574 13.9214 7.56348L13.9224 7.56445C13.7985 7.63432 13.6427 7.74232 13.4546 7.89551L13.2554 8.06445C12.8303 8.43772 12.3701 8.9155 11.8696 9.45508L11.355 10.0137C11.2083 10.1737 11.0578 10.3363 10.9058 10.5H20.4995V13.5H3.49953V10.5H6.44094C6.46351 10.4917 6.50895 10.4743 6.57766 10.4355L6.71144 10.3525C6.85653 10.2565 7.03357 10.12 7.24367 9.93555L7.45949 9.74023C7.96915 9.26549 8.52822 8.65816 9.14406 7.98633L9.65969 7.42578C10.1862 6.85795 10.7394 6.28081 11.2749 5.81055L11.5513 5.57617C11.8343 5.34497 12.1362 5.12744 12.4487 4.95117L12.7329 4.80469C13.0345 4.66323 13.3867 4.54419 13.7739 4.50977L13.7847 4.50879L13.7964 4.50781L13.978 4.5H20.4995Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

const MULTIPOINT_OFFSETS = [
  { top: 0, left: 8 },
  { top: 6, left: 1 },
  { top: 12, left: 9 },
];

export const MultiPointSymbol = ({
  pointShape,
  pointColor,
}: {
  pointShape?: JSX.Element;
  pointColor?: string;
}) => {
  if (pointShape) {
    return (
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          fontSize: "8px",
        }}
      >
        {MULTIPOINT_OFFSETS.map(({ top, left }) => (
          <Box
            key={`${top}-${left}`}
            sx={{
              position: "absolute",
              top,
              left,
              display: "grid",
              "& .MuiSvgIcon-root": {
                fontSize: "8px !important",
              },
            }}
          >
            <PointSymbol pointShape={pointShape} pointColor={pointColor} />
          </Box>
        ))}
      </Box>
    );
  } else {
    return (
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5" cy="10" r="2.5" fill={pointColor || "currentColor"} />
        <circle cx="11" cy="4" r="2.5" fill={pointColor || "currentColor"} />
        <circle cx="13" cy="14" r="2.5" fill={pointColor || "currentColor"} />
      </svg>
    );
  }
};

export const MagnetOutline = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 10.5H18.9998V12C18.9998 17 16.9998 20 11.9998 20C6.99977 20 4.99977 17 4.99977 12L4.99977 10.5H9L8.99977 12C9 15 9.99977 16 11.9998 16C13.9998 16 14.9998 15.1951 15 12V10.5Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M15.0003 5.00002C15.0002 4.44773 15.448 4 16.0003 4H18C18.5523 4 19 4.44772 19 5V7H15.0003L15.0003 5.00002Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M5.00002 5.00002C5.00001 4.44773 5.44773 4 6.00002 4H7.99976C8.55205 4 8.99977 4.44772 8.99977 5V7H5.00007L5.00002 5.00002Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export const MagnetFilled = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0005 10.5H19.0002L19.0002 12C19.0002 17 17.0002 20 12.0002 20C7.00023 20 5.00023 17 5.00023 12V10.5H9.00047L9.00023 12C9.00047 15 10.0002 16 12.0002 16C14.0002 16 15.0003 15.1951 15.0005 12L15.0005 10.5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M15.0005 5.00002C15.0005 4.44773 15.4482 4 16.0005 4H18.0002C18.5525 4 19.0002 4.44772 19.0002 5V7H15.0005L15.0005 5.00002Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M5.00026 5.00002C5.00025 4.44773 5.44796 4 6.00026 4H8C8.55228 4 9 4.44772 9 5V7H5.00031L5.00026 5.00002Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};
